import { CustomerResponseFragment } from '@stigg-types/apiTypes';

export function getCustomerDisplayName(customer?: CustomerResponseFragment | null) {
  if (!customer) {
    return '';
  }

  const customerIdentifier = customer.name || customer.email;

  if (!customerIdentifier) {
    return customer.customerId;
  }

  return `${customerIdentifier} (${customer.customerId})`;
}
